import { schema } from 'normalizr';
import {
  entitiesSelectorList,
  entitiesSelectorItem,
} from '../utils/asyncHelpers';

const schemaEntity = new schema.Entity('physicalPerson');

export const getPhysicalPersons = entitiesSelectorList(schemaEntity);
export const getPhysicalPerson = entitiesSelectorItem(schemaEntity);
export default schemaEntity;
